<template>
  <vis-inner-layout>
    <vis-loading size="md" v-if="loading" logo />
    <vis-error size="md" v-else-if="error" with-default logo :state="state" />
    <div
      v-else
      class="ba-relative ba-z-100 ba-w-full ba-max-w-sm sm:ba-w-auto sm:ba-max-w-none ba-max-h-full ba-m-auto ba-px-2 sm:ba-px-0 ba-py-10 md:ba-p-10 ba-text-base ba-shadow-xl ba-overflow-auto permission__content"
    >
      <header class="ba-text-center ba-text-white">
        <h1 class="ba-mb-4 ba-text-3xl">Приложение запрашивает разрешения</h1>
        <p class="ba-opacity-50">Снимите флажки с прав, которые Вы не хотите предоставлять</p>
      </header>
      <form class="ba-text-white permission__form" @submit.prevent>
        <div class="sm:ba-flex ba-m-4 ba-py-4 ba-border-t ba-border-b permission__form-inputs">
          <fieldset
            v-if="concentIdentityScopes.length"
            class="sm:ba-w-1/2 ba-mb-8 sm:ba-mb-0 sm:ba-mr-12"
          >
            <legend class="ba-text-lg sm:ba-text-xl">Персональная информация</legend>
            <vis-concent-scope
              v-for="scope in concentIdentityScopes"
              :key="scope.name"
              v-model="form.checkedIdentityScopes"
              :name="scope.name"
              :locked="formLoading || scope.required"
              :emphasize="scope.emphasize"
              :required="scope.required"
            />
          </fieldset>
          <fieldset v-if="concentApiScopes.length" class="sm:ba-w-1/2">
            <legend class="ba-text-lg sm:ba-text-xl">Доступ к приложению</legend>
            <vis-concent-scope
              v-for="scope in concentApiScopes"
              :key="scope.name"
              v-model="form.checkedApiScopes"
              :name="scope.name"
              :locked="formLoading || scope.required"
              :emphasize="scope.emphasize"
              :required="scope.required"
            />
          </fieldset>
        </div>
        <footer class="ba-mx-4 permission__form-footer">
          <p
            v-if="concentCanRemember"
            class="ba-w-full ba-my-5 ba-select-none input-wrap input-wrap--checkbox"
          >
            <input
              id="checkbox"
              type="checkbox"
              v-model="form.rememberDecision"
              :disabled="formLoading"
            />
            <label
              for="checkbox"
              class="ba-flex ba-justify-start ba-items-center sm:ba-text-lg ba-cursor-pointer"
            >Запомнить мой выбор</label>
          </p>
          <div class="sm:ba-flex">
            <button
              @click.prevent="concentAllow"
              :disabled="formLoading"
              class="ba-text-xl ba-rounded-full btn btn--login"
            >Разрешить</button>
            <button
              type="buttom"
              @click.prevent="concentCancel"
              :disabled="formLoading"
              class="sm:ba-flex-no-shrink sm:ba-w-48 sm:ba-ml-4 ba-text-xl ba-rounded-full btn btn--cancel"
            >Отмена</button>
          </div>
        </footer>
      </form>
    </div>
  </vis-inner-layout>
</template>

<script>
import VisInnerLayout from "./vis-inner-layout";
import VisConcentScope from "./vis-concent-scope";
import { concentMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-page-concent",
  components: {
    VisInnerLayout,
    VisConcentScope
  },
  mixins: [concentMixin]
};
</script>
